export default "__VITE_ASSET__BNr5TOjQ__"